export default __webpack_public_path__ + "static/media/misc-fireplaceA-1440w.93904d4c.png";